import { useRouter } from 'next/router';
import { Menu } from '@/constants/tos';
import { P } from '@/components/shadcn/typography';

interface Props {
  menu: Menu;
  page?: string;
}

const Nav = ({ menu, page }: Props) => {
  const router = useRouter();
  const activePage = page ? page : Object.values(menu)[0]?.target;

  return (
    <div className="left-0 top-[var(--header-height)] z-40 flex h-[80px] w-full items-center justify-center bg-transparent py-5">
      <div className="z-40 flex w-full max-w-xl justify-between">
        <P className="font-bold md:text-xl">Terms of Service</P>
        {Object.values(menu).map(item => (
          <div
            data-active={activePage === item.target}
            className="cursor-pointer hover:text-brand data-[active=true]:text-brand"
            key={item.title}
            onClick={() =>
              router.push(item.target, undefined, { shallow: true })
            }>
            {item.title}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Nav;
